import React, { useState } from 'react';
import { ViewPassword, HidePassword } from '../../Icon';
import './ChangeUserPassword.scss';
import { checkedImage, hideEyeGray, unCheckedImage, viewEyeGray } from '../../../assets/images';
import { PasswordResult } from '../../../screens/ChangeClientPassword/ChangeClientPassword';
import PasswordValidationCard from '../../commons/PasswordValidationCard/PasswordValidationCard';

type PasswordType = {
  newPassword: string;
  confirmNewPassword: string;
}

type AppProps = {
  toggleNewPassword: boolean;
  toggleConfirmPassword: boolean;
  disabled: boolean;
  passwordData: PasswordType;
  newPasswordError: string;
  confirmNewPasswordError: string;
  passwordPopUpShow: boolean;
  passwordValidationError: string;
  passwordValidation: PasswordResult;
  handleChangeNewPassword: (value: any) => void;
  popOver: (e: any) => void;
  handleChangeConfirmPassword: (value: any) => void;
  handleToggleNewPassword: () => void;
  handleToggleConfirmNewPassword: () => void;
}

const ChangeUserPassword = ({
  handleToggleNewPassword,
  handleToggleConfirmNewPassword,
  handleChangeConfirmPassword,
  handleChangeNewPassword,
  toggleConfirmPassword,
  toggleNewPassword,
  disabled,
  passwordData,
  confirmNewPasswordError,
  newPasswordError,
  passwordValidation,
  passwordPopUpShow,
  passwordValidationError,
  popOver
}: AppProps) => {
  return (
    <>
      <div className="form-group">
        <div className="password-input-position">
          <label htmlFor="formData"
          >Enter New Password</label>
          <input
            type={!toggleNewPassword ? "password" : "text"}
            className={`form-control ${(!!newPasswordError || !!passwordData?.newPassword && !!passwordValidationError) ? "error-border" : null}`}
            disabled={disabled}
            value={passwordData?.newPassword}
            autoComplete="off"
            // onBlur={popOver}
            onChange={(e: any) => handleChangeNewPassword(e)}
          />
          {!!newPasswordError && <small className="text-danger">{newPasswordError}</small>}
          {!!passwordData?.newPassword && !!passwordValidationError && <small className="text-danger">{passwordValidationError}</small>}
          <div className="icon-box" onClick={handleToggleNewPassword}>
            {toggleNewPassword ? <img src={viewEyeGray} alt="eye" /> : <img src={hideEyeGray} alt="eye" />}
          </div>
          {passwordData?.newPassword?.length &&
            passwordPopUpShow &&
            Object.values(passwordValidation).includes(false) ? (
            <PasswordValidationCard
                className={"tooltext-right position-absolute"}
                triangleClassName={"triangle-right position-absolute"}
                isLeast={passwordValidation?.atLeast}
                isUpperCase={passwordValidation?.upperCase}
                isLowerCase={passwordValidation?.lowerCase}
                isSpecial={passwordValidation?.special}
                isNumber={passwordValidation?.number}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="form-group">
        <div className="password-input-position">
          <label htmlFor="formData"
          >Confirm New Password</label>
          <input
            type={!toggleConfirmPassword ? "password" : "text"}
            className={`form-control ${!!confirmNewPasswordError ? "error-border" : null}`}
            disabled={disabled}
            value={passwordData?.confirmNewPassword}
            autoComplete="off"
            onChange={(e: any) => handleChangeConfirmPassword(e)}
          />
          {!!confirmNewPasswordError && <small className="text-danger">{confirmNewPasswordError}</small>}
          <div className="icon-box" onClick={handleToggleConfirmNewPassword}>
            {toggleConfirmPassword ? <img src={viewEyeGray} alt="eye" /> : <img src={hideEyeGray} alt="eye" />}
          </div>
        </div>
      </div>
    </>
  )
};

export default ChangeUserPassword;